import React, { createRef, useRef, useState } from 'react'

interface RPresults {
  results: any
  setLoadResultsFlag: any
}

const RPresults: React.FC<RPresults> = ({ results, setLoadResultsFlag }) => {
  const [parseRes, setParseRes] = useState<any>(results.data)

  const handleNavigate = () => {
    setLoadResultsFlag(false)
  }

  const resumeParserResActionMenuRef = useRef<any[]>([])
  resumeParserResActionMenuRef.current = parseRes.map(
    (item: any, i: number) => resumeParserResActionMenuRef.current[i] ?? createRef()
  )

  return (
    <>
      <div className='card-header mt-5'>
        <div className='card-title col-5 align-items-start flex-row'>
          <span className='mt-1 text-hover-primary' onClick={handleNavigate}>
            <i className='bi bi-arrow-left' style={{ fontSize: '1.75rem' }}></i>
          </span>
          <div className='d-flex flex-column ms-7'>
            <span className='card-label fw-bolder fs-3 mb-1'>Resume Parser results</span>
            <span className='text-muted mt-1 fw-bold fs-7'>
              Shortlisted profiles aligned with the specified requirements
            </span>
          </div>
        </div>
      </div>

      <div className='row gy-10 g-xl-12'>
        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <table
              id='kt_profile_overview_table'
              className='table table-row-bordered table-row-dashed gy-4 align-middle fw-bold'
            >
              <thead className='fs-7 text-gray-400 text-uppercase'>
                <tr>
                  <th>contact number</th>
                  <th>email</th>
                  <th>Exp valid</th>
                  <th>shortlisted</th>
                  <th>Must Have Skills Accuracy</th>
                  <th>Optional Skills Accuracy</th>
                  <th>Skills</th>
                  <th>Work Exp</th>
                  {/* <th className='min-w-100px text-center'>Action</th> */}
                </tr>
              </thead>
              <tbody className='fs-6'>
                {parseRes.map((rec: any, index: number) => {
                  return (
                    <tr>
                      <td>{rec.contact_number}</td>
                      <td>{rec.email}</td>
                      <td>{rec.is_experience_valid ? 'Yes' : 'No'}</td>
                      <td>{rec.is_shortlisted ? 'Yes' : 'No'}</td>
                      <td>{rec.must_have_skills_accuracy}</td>
                      <td>{rec.optional_skills_accuracy}</td>
                      <td>{rec.skills}</td>
                      <td>{rec.work_experience_years}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default RPresults
